const api = {
    getBlogList: "/sunnback/blog/getBlogList", //获取随笔
    getBlogInfo: "/sunnback/blog/getBlogInfo", //获取随笔详情
    getSiteStats: "/sunnback/blog/getSiteStats", //获取网站统计
    getTodayStats: "/sunnback/blog/getTodayStats", //获取今日数据
    getArticleData: "/sunnback/blog/getArticleData",//获取文章数据
    visit: "/sunnback/blog/visit", //增加访问记录
    reading: "/sunnback/blog/reading",//增加阅读量
    like: "/sunnback/blog/like",//增加文章点赞
    addComment: "/sunnback/blog/addComment",//添加评论
    getLabel: "/sunnback/blog/getTerm",//获取分类
    addTerm: "/sunnback/blog/addTerm",//增加分类
    contribute: "/sunnback/blog/contribute",//增加投递
    getTopTen: "/sunnback/blog/getTopTen",//获取前十数据
}

export default api;